import React, { Component } from 'react';
import { Box, Button, Card, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import FacturePreview from '../../Society/FacturePreview';
// import SignatureCanvas from 'react-signature-canvas'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchSociety } from '../../../../store/actions/userAction'
import Dialog from '../../../common/Dialog';
import { PrintRounded } from '@mui/icons-material';
import Currency from '../../../common/Currency';
import EquipementDetails from '../Single/EquipementDetails';

const OP = {
    REMISE: {title: "REMISE", action: "Mis à disposition", key:"start"},
    RECUP: {title: "RETOUR", action: "Récupéré", key:"end"}
}
class ContractBase extends Component {
    state = {  }
    // componentDidMount() {
    //     console.log("heyyyyyyyyyy")
    // }
    render() {
        const { SOCIETY, EQUIP, loan, user } = this.props;
        // window.print()
        return (
            // <Dialog
            //     maxWidth="md"
            //     open={true}
            // > // print not working in dialog
            <Box>
                {/* <IconButton onClick={() => window.print()}><PrintRounded /></IconButton>   NOT WORKING!! */}
                    
                <FacturePreview>
                    <Box p={4} style={{lineHeight: "30px"}}>
                        <Box p={2}>
                            <Box p={1} style={{textAlign: "center", background:"#ffbe00" }}>
                                <Typography variant="h5" gutterBottom >ETAT DE {OP[this.props.opType].title} CONTRADICTOIRE</Typography>
                            </Box>
                            <Box p={1} />
                            <Box>
                                Nous, soussignés <b>La société {SOCIETY.society_name}</b> au capital de <Currency value={SOCIETY.society_capital} />, immatriculée au registre de commerce
                                et de crédit mobilier sous le numéro <b style={{ whiteSpace: "nowrap"}}>{SOCIETY.society_matricule}</b> et dont
                                le siège est sis à {SOCIETY.society_city} {SOCIETY.society_address2},  <br />
                                agissant en la personne de son gérant en exercice, <b>{SOCIETY.society_dg}</b>, reconnais avoir :
                                <Box p={1}>
                                    <li><b>{OP[this.props.opType].action}</b></li>
                                </Box>
                                Des mains de <b>{user.lastname} {user.username}</b> le matériel ci-après
                            </Box>
                            {/* <Box>
                                Nous, soussignés <b>La société {SOCIETY.society_name}</b>, Société Actions Simplifiée,
                                au capital de FCFA Cent millions, immatriculée au registre de commerce
                                et de crédit mobilier sous le numéro <b>{SOCIETY.society_matricule}</b> et dont
                                le siège est sis à {SOCIETY.society_city} au quartier Vedoko N°1481,  <br />
                                agissant en la personne de son gérant en exercice, <b>{SOCIETY.society_dg}</b>, reconnais avoir :
                                <Box p={1}>
                                    <li><b>Mis à disposition / Stagiaires / Technique</b></li>
                                </Box>
                                Des mains de <b>{user.lastname} {user.username}</b> le matériel ci-après
                            </Box> */}
                            <Box>
                                <Table className="tableall">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>N°</TableCell>
                                            <TableCell>Désignation</TableCell>
                                            <TableCell>Quantité</TableCell>
                                            <TableCell>Etat</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>01</TableCell>
                                            <TableCell><b>{EQUIP.equipement_name} {EQUIP.equipement_brand}</b> <br /> SN n°<b>{EQUIP.equipement_sn}</b></TableCell>
                                            <TableCell>1</TableCell>
                                            <TableCell>{loan[`equipement_state_${OP[this.props.opType].key}`]}</TableCell>
                                        </TableRow>
                                        {/* <TableRow>
                                            <TableCell></TableCell>
                                        </TableRow> */}
                                    </TableBody>
                                </Table>
                            </Box>
                            <Box>
                                Le présent état pour en attester de l’état et pour faire valoir ce que de droit 
                            </Box>
                            <Box p={2} />
                            <Box p={2} style={{textAlign: "center"}}>
                                <Box>Fait en double exemplaires à <b> {SOCIETY.society_city}, le {new Date(loan[`loan_${OP[this.props.opType].key}_date`]).toLocaleDateString("fr-FR")}</b></Box>
                                <Box style={{textDecoration: "underline"}}>Ont lu, approuvé et signé</Box>
                            </Box>


                            <Box p={8} /> 
                            {/* espace signatures */}
                            {/* <Card>
                                <SignatureCanvas 
                                    penColor='green'
                                    canvasProps={{width: 500, height: 200, className: 'sigCanvas'}} 
                                />
                            </Card> */}
                            <Box style={{ display: "flex", justifyContent: "space-between"}}>
                                <Box><b>La société {SOCIETY.society_name}</b></Box>
                                <Box><b>{user.lastname} {user.username}</b></Box>
                            </Box>
                        </Box>
                    </Box>
                </FacturePreview>
            </Box>
            // </Dialog>
        );
    }
}

function mapStateToProps(state){
    return { 
        // STATE: state.request,
        SOCIETY: state.society
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        // newSociety,
        fetchSociety
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ContractBase);





// Nous, soussignés La société ARESS SAS, Société Actions Simplifiée, au capital de FCFA Cent millions, immatriculée au registre de commerce et de crédit mobilier sous le numéro RCCM RB/AB/C/-13_B_18 et dont le siège est sis à Cotonou au quartier Vedoko N°1481, agissant en la personne de son gérant en exercice, monsieur Léonide M. SINSIN, reconnais avoir : 
// Mis à disposition / Stagiaires / Technique 
// Des mains de M. KOULETIO Cyriano le matériel ci-après. 
// N°      Désignation     Quantité        Etat
// 01  Routeur MTN 4G CPE R0516 
//     IMEI : 867784040849102
// 01
// Neuf
// 02
// Sim de connexion MTN 56 83 96 00
// 01
// Neuf

// Le présent état pour en attester de l’état et pour faire valoir ce que de droit 

// Fait en double exemplaires à
// Cotonou, le 04 août 2022
// Ont lu, approuvé et signé



// La Société ARESS SAS 	          M. KOULETIO Cyriano





// Audit-Conseil-Fourniture-Vente-Installation-Maintenance-Ingénierie en Énergie
// RCCM RB/ ABC  13B18 - N°IFU 3201201523512 - C.S de 100.000.000 FCFA
